// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 4/16/2024 9:51:31 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

// todo: imports were removed because of broken naming (paths) => some requests were removed because of it

export interface ProcessMigrationRequestInterface {
  workflowInstanceKey: string;
}

export interface ProcessMigrationResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface KickoffMigrationRequestInterface {
  workflowInstanceKey: string;
}

export interface KickoffMigrationResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ReverseMigrationRequestInterface {
  companyIdV1: string;
}

export interface ReverseMigrationResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ExecuteActionRequestInterface {
  companyId: number;
  resendAdminInvite: boolean;
  userId?: number;
}

export interface ExecuteActionResponseInterface {
  validationResults: ValidationResultsInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class MigrationOneManagerService {
  processMigration(request: ProcessMigrationRequestInterface): Promise<ProcessMigrationResponseInterface> {
    return Post('/PayrollMigrationOneManager/processMigration', request);
  }

  kickoffMigration(request: KickoffMigrationRequestInterface): Promise<KickoffMigrationResponseInterface> {
    return Post('/PayrollMigrationOneManager/kickoffMigration', request);
  }

  reverseMigration(request: ReverseMigrationRequestInterface): Promise<ReverseMigrationResponseInterface> {
    return Post('/PayrollMigrationOneManager/reverseMigration', request);
  }

  executeAction(request: ExecuteActionRequestInterface): Promise<ExecuteActionResponseInterface> {
    return Post('/PayrollMigrationOneManager/executeAction', request);
  }
}

export default new MigrationOneManagerService();
